export const LOAD_ADMIN_USERS_WITH_TEAMS = "LOAD_ADMIN_USERS_WITH_TEAMS";

export const LOAD_ADMINUSERS_WITH_TEAMS_SUCCESS = "LOAD_ADMINUSERS_WITH_TEAMS_SUCCESS";
